import { Link } from "react-router-dom";
import { CATEGORY_LOCATION } from "../../utils/enums";
import { useStore } from "../../store";
import { useCategories } from "../../hooks/queries";
import NewsletterStrip from "../NewsletterStrip";

interface SocialLink {
  href: string;
  icon: string;
  label: string;
}

const SOCIALS: SocialLink[] = [
  {
    href: "https://www.instagram.com/bolle_ig?igsh=cnExb2JtdW45M3d4&utm_source=qr",
    icon: "bi-instagram",
    label: "Instagram",
  },
  {
    href: "https://www.facebook.com/share/yVxsKQRGU88qyexf/?mibextid=LQQJ4d",
    icon: "bi-facebook",
    label: "Facebook",
  },
  {
    href: "https://linkedin.com/company/boll-e",
    icon: "bi-linkedin",
    label: "LinkedIn",
  },
  { href: "https://x.com/bolle_twt?s=11", icon: "bi-twitter-x", label: "X" },
  {
    href: "https://www.tiktok.com/@bolle_tiktok?_t=8pSzb3fLFdQ&_r=1",
    icon: "bi-tiktok",
    label: "TikTok",
  },
];

function Footer() {
  const { isFromPrelaunch } = useStore((s: any) => s);
  const { data: allCats = [] } = useCategories();
  const cats = allCats.filter(
    (k: any) => k?.location === CATEGORY_LOCATION.HEADER,
  );

  return (
    <>
      {!isFromPrelaunch && <NewsletterStrip />}
      <div className="footerMain">
        <div className="container">
          <div className="row gy-4">
            <div className="col-12 col-lg-5 footerMain__brand">
              <Link to="/" className="footerMain__logo">
                <img
                  src="/assets/imgs/white-logo.svg"
                  alt="Boll-e"
                  width={72}
                  height={72}
                />
              </Link>
              <p className="footerMain__tagline">
                The floor every artist deserved. The discovery every collector
                wanted.
              </p>
              <div>
                <h4 className="footerMain__heading">Follow us</h4>
                <div className="footerMain__socials">
                  {SOCIALS.map((s) => (
                    <a
                      key={s.href}
                      href={s.href}
                      target="_blank"
                      rel="noreferrer"
                      className="footerMain__social"
                      aria-label={s.label}
                    >
                      <i className={`bi ${s.icon}`} aria-hidden="true"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="col-6 col-md-4 offset-lg-2 col-lg-2 footer-links">
              <h4 className="footerMain__heading">Categories</h4>
              <ul className="footerMain__list">
                <li>
                  <Link to="/">
                    <i
                      className="bi bi-chevron-right footerMain__chevron"
                      aria-hidden="true"
                    ></i>
                    <span>All</span>
                  </Link>
                </li>
                {cats?.map((k: any, idx: number) => (
                  <li key={idx}>
                    <Link to={`/explore/${k?._id}`} className="cursor-pointer">
                      <i
                        className="bi bi-chevron-right footerMain__chevron"
                        aria-hidden="true"
                      ></i>
                      <span>{k?.name}</span>
                    </Link>
                  </li>
                ))}
                <li>
                  <Link to="/explore/others">
                    <i
                      className="bi bi-chevron-right footerMain__chevron"
                      aria-hidden="true"
                    ></i>
                    <span>Others</span>
                  </Link>
                </li>
              </ul>
            </div>

            <div className="col-6 col-md-4 col-lg-3 footer-links">
              <h4 className="footerMain__heading">Help &amp; support</h4>
              <ul className="footerMain__list">
                <li>
                  <Link to="/help-and-support?to=how-it-works">
                    <i
                      className="bi bi-chevron-right footerMain__chevron"
                      aria-hidden="true"
                    ></i>
                    <span>How it works</span>
                  </Link>
                </li>
                <li>
                  <Link to="/help-and-support?to=faqs">
                    <i
                      className="bi bi-chevron-right footerMain__chevron"
                      aria-hidden="true"
                    ></i>
                    <span>FAQs</span>
                  </Link>
                </li>
                <li>
                  <Link to="/help-and-support?to=contact-us">
                    <i
                      className="bi bi-chevron-right footerMain__chevron"
                      aria-hidden="true"
                    ></i>
                    <span>Contact us</span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <hr className="footerMain__divider" />

          <div className="footerMain__copyRow">
            <p className="m-0">
              &copy; {new Date().getFullYear()} Boll-e&trade;. All rights
              reserved.
            </p>
            <a
              href={
                isFromPrelaunch
                  ? "/terms-and-conditions?ref=prelaunch"
                  : "/terms-and-conditions"
              }
              target="_blank"
              rel="noreferrer"
              className="footerMain__termsLink"
            >
              Terms &amp; Conditions
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
